export interface Consent {
  consentTextId: ConsentTextId;
  effectiveFrom: number;
  text: string;
  textHash: string;
  consentStatus: ConsentStatus;
  reConsentRequired?: boolean;
}

export interface ConsentGroup {
  consentGroup: string;
  introductionText: string;
  afterwordText: string;
  consents: Consent[];
  consentTexts: Consent[];
}

export interface ConsentData {
  [key: string]: boolean;
}

export enum ConsentStatus {
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  WITHDRAWN = 'withdrawn',
}

export enum ConsentTextId {
  SMS_MESSAGING = 'fplus-marketing-sms-messaging',
  THIRD_PARTY_OFFERS = 'fplus-marketing-third-party-offers',
  MEMBER_OFFERS = 'fplus-marketing-member-offers',
  FLIGHT_OFFERS = 'fplus-marketing-flight-offers',
  COOKIE_PERSONALIZATION = 'f-cookies-personalization',
  COOKIE_ANALYTICS = 'f-cookies-analytics',
  COOKIE_ADVERTISING = 'f-cookies-advertising',
  NOT_REAL_CONSENT_VALUE = 'not-real-consentValue',
}
